<template>
  <div>
    <vxe-card size="mini" width="100%">
      <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
    </vxe-card>
    <pack-table ref="packs" :data-sources="dataSources" :limit-types="limitTypes" :shapes="shapes"/>
    <location-limit-table ref="locLimits" :limit-types="limitTypes"/>
    <inventory-limit-table ref="invLimits"/>
  </div>
</template>
<script>
import PackTable from '@/views/basedata/item/PackTable.vue'
import LocationLimitTable from '@/views/basedata/item/LocationLimitTable.vue'
import InventoryLimitTable from '@/views/basedata/item/InventoryLimitTable.vue'

export default {
  name: 'ItemExtra',
  components: { PackTable, LocationLimitTable, InventoryLimitTable },
  props: {
    dataSources: {
      type: Array,
      default: []
    },
    limitTypes: {
      type: Array,
      default: []
    },
    shapes: {
      type: Array,
      default: []
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    refresh(item) {
      this.$refs.packs.refresh(item)
      this.$refs.locLimits.refresh(item)
      this.$refs.invLimits.refresh(item)
    }
  }
}
</script>